import { default as Wrapper } from './Wrapper.vue'
import { default as Content } from './Content.vue'
import { default as Background } from './Background.vue'
import { default as Heading } from './Heading.vue'
import { default as Text } from './Text.vue'

export default {
  Wrapper,
  Content,
  Background,
  Heading,
  Text,
}
